import { useEffect, useState } from "react";
import { BaseClient, UseApiClientsProps, UseApiClientsState } from "./types.js";

export const useInitApiClients = <Client extends BaseClient, StaffClient extends BaseClient>({
    buildClients,
    buildStaffClients,
}: UseApiClientsProps<Client, StaffClient>): UseApiClientsState<Client, StaffClient> => {
    const [clients, setClients] = useState<UseApiClientsState<Client, StaffClient>["clients"]>([]);
    const [staffClients, setStaffClients] = useState<UseApiClientsState<Client, StaffClient>["staffClients"]>([]);
    const [initialized, setInitialized] = useState<boolean>(false);

    useEffect(() => {
        const { clients: clientsBuilded, hasCorrectApiUrl } = buildClients();
        setClients(clientsBuilded);
        if (hasCorrectApiUrl !== undefined) setInitialized(hasCorrectApiUrl);
    }, [buildClients]);

    useEffect(() => {
        const { staffClients: staffClientsBuilded, hasCorrectApiUrl } = buildStaffClients();
        setStaffClients(staffClientsBuilded);
        if (hasCorrectApiUrl !== undefined) setInitialized(hasCorrectApiUrl);
    }, [buildStaffClients]);
    return { clients, staffClients, initialized };
};
